import { getFixedT } from 'i18next';

import type { Maybe } from 'common/types';
import type { CommentType } from 'features/call/call-comments/enums';
import { AbuseCommentType } from 'features/call/call-comments/enums';
import type { CallCommentsFormValues } from 'features/call/call-comments/interfaces';
import { AbuseReasonValue } from 'features/call/vrs-call-comments/enums';
import type { VrsCallCommentsAbuseForm } from 'features/call/vrs-call-comments/interfaces';

export const useVrsCallCommentsAbuseForm = () => {
  const ct = getFixedT('en');
  const t = getFixedT('en', 'translation', 'abuseCommentText');
  const reasonTranslate = getFixedT(
    'en',
    'translation',
    'abuseCommentText.reason'
  );

  const getHarassmentQuestionString = (
    harassmentQuestions: Maybe<string[]>
  ): string => {
    if (harassmentQuestions?.length) {
      const translatedHarassmentQuestions = harassmentQuestions.map(
        (question) => reasonTranslate(question)
      );
      return `${t('other')}: ${translatedHarassmentQuestions.join(', ')}. `;
    }

    return '';
  };

  const getCommentTypesByReason = (commentReason: string): CommentType[] => {
    return [
      commentReason === AbuseReasonValue.HARASSMENT
        ? AbuseCommentType.ABUSTERP
        : AbuseCommentType.ABUSE2,
    ];
  };

  const combineCommentText = ({
    commentReason,
    commentScenario,
    incidentType,
    personType,
    witnessType,
    commentText,
    harassmentQuestions,
  }: VrsCallCommentsAbuseForm): string => {
    const commentString = commentText ? `${commentText}. ` : '';
    const reasonString = `${t('containerTitle')}: ${t(commentReason)}. `;
    const scenarioString = `${t('scenario')}: ${reasonTranslate(
      commentScenario
    )}. `;
    const incidentString = `${t('incidentTitle')}: ${t(incidentType)}. `;
    const personString = `${t('personTitle')}: ${t(personType)}. `;
    const witnessString = `${t('witnessTitle')}: ${ct(witnessType)}.`;
    const harassmentString = getHarassmentQuestionString(harassmentQuestions);

    return (
      commentString +
      reasonString +
      scenarioString +
      harassmentString +
      incidentString +
      personString +
      witnessString
    );
  };

  const prepareFormData = (
    formData: VrsCallCommentsAbuseForm
  ): CallCommentsFormValues => {
    const commentTypes = getCommentTypesByReason(formData.commentReason);
    const commentText = combineCommentText(formData);

    return {
      commentTypes,
      commentText,
    };
  };

  return { prepareFormData };
};
